import { ACTION, type Action, type Resource } from '@/constants/permissions'

/** Compose a permission string as the API expects: `${resource}:${action}`. */
export function permissionKey(resource: Resource, action: Action): string {
  return `${resource}:${action}`
}

/**
 * Check whether a set of granted permission strings satisfies a required
 * resource+action. A `${resource}:manage` grant implies every action on that
 * resource (mirrors tap-api's authorize middleware semantics).
 */
export function hasPermission(
  granted: readonly string[],
  resource: Resource,
  action: Action,
): boolean {
  const grantedSet = new Set(granted)
  return (
    grantedSet.has(permissionKey(resource, action)) ||
    grantedSet.has(permissionKey(resource, ACTION.MANAGE))
  )
}
